import { useNavigate } from 'react-router-dom';
import { useSmartBack } from '../hooks/useSmartBack';

export default function NotFound() {
  const navigate = useNavigate();
  const goBack = useSmartBack('/');

  return (
    <div className="min-h-full bg-[var(--v-surface-1)] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* 404 Graphic */}
        <div className="mb-8">
          <div className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">
            404
          </div>
          <div className="text-6xl mt-4">🏠</div>
        </div>

        <h1 className="text-2xl font-bold text-[var(--v-text-primary)] mb-2">
          Page Not Found
        </h1>
        <p className="text-slate-400 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have been moved or doesn't exist.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={goBack}
            className="px-6 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-lg font-medium transition flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Go Home
          </button>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-slate-500 text-sm mb-4">Popular pages</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {[
              { label: 'Dashboard', path: '/' },
              { label: 'Create QR', path: '/?tab=create' },
              { label: 'Visitors', path: '/?tab=visitors' },
              { label: 'Profile', path: '/?tab=profile' }
            ].map((link) => (
              <button
                key={link.path}
                onClick={() => navigate(link.path)}
                className="px-3 py-1 bg-[var(--v-surface-1)] hover:bg-slate-700 text-slate-400 hover:text-white rounded text-sm transition"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        {/* Footer */}
        <p className="mt-8 text-slate-600 text-xs">
          If you believe this is an error, please contact support.
        </p>
      </div>
    </div>
  );
}
